var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"close":_vm.close},on:{"click:close":_vm.emitClickClose}},[_c('sales-person-avatar',{attrs:{"sales-person":_vm.salesPerson,"left":"","color":"white"}}),_vm._v(" "+_vm._s(_vm.salesPersonName)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }